import request from "utils/api";
import { notification } from "antd";
import moment from "moment";
import { DAY_NUMBER, ROLES_LIST_PERMISSION } from "utils/constants";
import { geocodeByAddress, getLatLng } from "react-places-autocomplete";
import { parsePhoneNumber } from "react-phone-number-input";
import i18n from "i18n";
import "moment/locale/vi"; // without this line it didn't work
import { uploadLargeFile } from "./uploadHelper";

const Helper = {
  getAuthToken: () => localStorage.getItem("op_token"),
  storeAuthToken: (token) => localStorage.setItem("op_token", token),
  removeAuthToken: () => localStorage.removeItem("op_token"),

  uploadFile: async (file, onProgress) => {
    if (file) {
      try {
        return await uploadLargeFile(file.file, onProgress);
      } catch (e) {
        console.error("Upload failed:", e);
        return null;
      }
    }
    return null;
  },
  toastr: (description, message, type = "success", placement) => {
    const content = {
      message,
      description,
      placement,
    };
    if (type === "success") {
      notification.success(content);
    } else if (type === "error") {
      notification.error(content);
    }
  },
  arrayToString: (array = []) => array.map((item) => item).join(", "),

  checkEmptyHtmlRaw: (content) => {
    if (typeof content !== "string") {
      return false;
    }
    return content.replace(/<p>|&nbsp;|<\/p>/gi, "").trim() === "";
  },

  formatParams: (searchObject, { arrayParams = [] }) => {
    function capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }
    Object.keys(searchObject).forEach((key) => {
      if (arrayParams.includes(key) && typeof searchObject[key] === "string") {
        searchObject[key] = [searchObject[key]];
      }
    });
    const { orderBy = "createdAt" } = searchObject;
    const asc = searchObject.order === "descend" ? -1 : 1;
    if (orderBy === "createdAt") {
      searchObject.sort = asc;
      delete searchObject.sortTitle;
      delete searchObject.sortEmail;
      delete searchObject.sortAccuracy;
      delete searchObject.sortName;
      delete searchObject.sortState;
      delete searchObject.sortGuarantee;
      delete searchObject.sortAmount;
      delete searchObject.sortPrice;
      delete searchObject.sortPromotionPrice;
    } else {
      searchObject[`sort${capitalizeFirstLetter(orderBy)}`] = asc;
      Object.keys(searchObject).forEach((i) => {
        if (
          i.startsWith("sort") &&
          i !== `sort${capitalizeFirstLetter(orderBy)}`
        ) {
          delete searchObject[i];
        }
      });
    }
    return searchObject;
  },
  getTimeStamp: (date) => {
    const timePost = moment(date);
    const currentTime = moment();
    timePost.locale("vi");
    if (!date || !timePost.isValid()) {
      return "";
    }
    if (currentTime.diff(timePost, "s") < 60) {
      return "Vừa nãy";
    }

    if (currentTime.diff(timePost, "m") < 60) {
      return `${currentTime.diff(timePost, "m")} phút trước`;
    }

    if (currentTime.diff(timePost, "h") < 24) {
      return `${currentTime.diff(timePost, "h")} giờ trước`;
    }

    if (currentTime.diff(timePost, "d") <= 7) {
      return `${currentTime.diff(timePost, "d")} ngày trước`;
    }

    return timePost.format("DD/MM/YYYY");
  },
  sortUserPermission: (userPermission = []) => {
    if (!Array.isArray(userPermission)) {
      return [];
    }
    const defaultOrder = Object.keys(ROLES_LIST_PERMISSION).map(
      (key) => ROLES_LIST_PERMISSION[key].value
    );

    return defaultOrder.filter((item) => {
      const permission = userPermission.find((per) => per === item);
      return !!permission;
    });
  },
  convertObjectToOptions: (object, emptyOption = false, emptyLabel = "") => {
    const options = Object.keys(object).map((key) => ({
      value: key,
      label: object[key],
    }));
    if (emptyOption) {
      options.unshift({
        value: "",
        label: emptyLabel,
      });
    }
    return options;
  },
  formatPrice: (number) => {
    if (number < 1e3) return number;
    if (number >= 1e3 && number < 1e6) return `${+(number / 1e3).toFixed(1)}K`;
    if (number >= 1e6 && number < 1e9) return `${+(number / 1e6).toFixed(1)}M`;
    if (number >= 1e9 && number < 1e12) return `${+(number / 1e9).toFixed(1)}B`;
    if (number >= 1e12) return `${+(number / 1e12).toFixed(1)}T`;
    return "";
  },

  convertMinutesToMoment: (num) => {
    const hours = Math.floor(num / 60);
    const minutes = num % 60;
    return moment(
      `${hours.toLocaleString("en-US", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      })}:
    ${minutes.toLocaleString("en-US", {
      minimumIntegerDigits: 2,
      useGrouping: false,
    })}`,
      "HH:mm"
    );
  },
  calculateRemainingTime(givenTime, targetRemainingHours = 2) {
    // Parse the given time string to create a Date object
    const givenDateTime = new Date(givenTime);

    // Get the current time
    const currentDateTime = new Date();

    // Calculate the time difference in milliseconds
    const timeDifference = givenDateTime.getTime() - currentDateTime.getTime();

    // Convert milliseconds to hours and minutes
    const remainingHours = Math.floor(timeDifference / (1000 * 60 * 60));
    const remainingMinutes = Math.floor(
      (timeDifference % (1000 * 60 * 60)) / (1000 * 60)
    );
    // if remaining hours is less than to target remaining hours (2 hours) and remaining minutes is greater than 0, return the remaining time
    if (remainingHours < targetRemainingHours && remainingMinutes > 0) {
      // Format the result
      const remainingTime = i18n.t("productDetail.time", {
        hour: remainingHours,
        minute: remainingMinutes,
      });

      return remainingTime;
    }
    return null;
  },
  formatTimeInDate: (number) => {
    const hourValue = Math.floor(number / 60);
    const hourDisplay = hourValue > 12 ? hourValue - 12 : hourValue;
    const minuteValue = number % 60;
    const minuteDisplay = minuteValue >= 10 ? minuteValue : `0${minuteValue}`;
    const isAnteMeridiem = hourValue < 12 ? "AM" : "PM";
    return `${hourDisplay}:${minuteDisplay} ${isAnteMeridiem}`;
  },
  getLatLng: async (address, initLatLng = {}) => {
    try {
      const result = await geocodeByAddress(address);
      const latLng = await getLatLng(result[0]);
      return {
        lng: latLng.lng,
        lat: latLng.lat,
      };
    } catch {
      return {
        lng: initLatLng.lng || 106.6,
        lat: initLatLng.lat || 10.7,
      };
    }
  },
  formatPhone: (phone, countryCode) => {
    const parsedPhone = parsePhoneNumber(`${countryCode}${phone}`);
    if (parsedPhone) {
      return parsedPhone.number;
    }
    return "";
  },
  getMessageTimeStamp: (date) => {
    if (!date) {
      return null;
    }
    const messageDate = moment(date);
    messageDate.locale("vi");
    const timeDif = moment().diff(moment(date), "d");
    const TODAY = moment().startOf("d");
    const YESTERDAY = moment().subtract(1, "days").startOf("day");

    if (messageDate.isSame(TODAY, "day")) {
      return messageDate.format("HH:mm");
    }
    if (messageDate.isSame(YESTERDAY, "day")) {
      return `Hôm qua, ${messageDate.format("HH:mm")}`;
    }
    if (timeDif <= 7) {
      return messageDate.format("dddd HH:mm");
    }
    return messageDate.format("DD/MM/YY HH:mm");
  },
  getTimeNotification: (date, dateFormat) => {
    if (!moment(date, dateFormat).isValid()) {
      return undefined;
    }
    const translatedExpityDateFormat = `YYYY${i18n.t(
      "constants.dateCharacter.year"
    )}MM${i18n.t("constants.dateCharacter.month")}DD${i18n.t(
      "constants.dateCharacter.day"
    )}`;
    const dateStringTranslated = moment(date, dateFormat).format(
      translatedExpityDateFormat
    );
    const today = new Date();
    const notificationTime = new Date(date);
    const diffMs = today - notificationTime; // milliseconds between now & notification time
    const diffDays = Math.floor(diffMs / 86400000); // days
    const diffHrs = Math.floor((diffMs % 86400000) / 3600000); // hours
    const diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000); // minutes
    if (diffDays < 0) {
      return "Vừa xong";
    }
    if (diffDays === 0) {
      if (diffHrs === 0) {
        if (diffMins === 0) {
          return "Vừa xong";
        }
        return `${diffMins} phút trước`;
      }
      return `${diffHrs} giờ trước`;
    }
    if (diffDays > 7) {
      return dateStringTranslated;
    }
    return `${diffDays} ngày trước`;
  },
  uploadVideo: async (file) => {
    if (file) {
      const payload = new FormData();
      payload.append("file", file.file);

      try {
        const data = await request("/api/upload/upload-video", payload);
        return data[0];
      } catch (e) {
        return null;
      }
    }
    return null;
  },
  uploadImage: async (file) => {
    if (file) {
      const payload = new FormData();
      payload.append("file", file.file);

      try {
        return await request("/api/upload/upload-image", payload);
      } catch (e) {
        return null;
      }
    }
    return null;
  },
  sortStringWithoutSpecialChars: (sourceString) => {
    // eslint-disable-next-line no-useless-escape
    const outString = sourceString.replace(
      // eslint-disable-next-line no-useless-escape
      /[*()+\?;:'",.<>\{\}\[\]\\\/]/gi,
      ""
    );
    return outString;
  },
  getSessionId: () => {
    if (!window.sessionStorage) {
      return "";
    }

    let savedSessionId = window.sessionStorage.getItem("sessionId");
    if (!savedSessionId) {
      const randomSessionId = Math.random().toString(36).substring(7);
      window.sessionStorage.setItem("sessionId", randomSessionId);
      savedSessionId = randomSessionId;
    }

    return savedSessionId;
  },
  showOpenningTime: (openningTime) => {
    let DAY = "";
    if (DAY_NUMBER === 0) {
      DAY = "Thứ hai";
    } else if (DAY_NUMBER === 1) {
      DAY = "Thứ ba";
    } else if (DAY_NUMBER === 2) {
      DAY = "Thứ tư";
    } else if (DAY_NUMBER === 3) {
      DAY = "Thứ năm";
    } else if (DAY_NUMBER === 4) {
      DAY = "Thứ sáu";
    } else if (DAY_NUMBER === 5) {
      DAY = "Thứ bảy";
    } else if (DAY_NUMBER === 6) {
      DAY = "Chủ nhật";
    }
    if (openningTime?.[DAY_NUMBER]?.alwaysDiscount) {
      return `${DAY}: ${i18n.t("menu.alwaysDiscount")}`;
    }
    if (openningTime?.[DAY_NUMBER]?.noDiscount) {
      return `${DAY}: ${i18n.t("menu.noDiscount")}`;
    }
    if (openningTime && openningTime?.[DAY_NUMBER]?.time) {
      const workingTimeListInCurrentDay = openningTime?.[DAY_NUMBER]?.time;
      const workingTimeResult = workingTimeListInCurrentDay.map(
        (item) => `${item?.from} - ${item?.to}`
      );
      return `${DAY}: ${workingTimeResult.join(", ")}`;
    }
    return "Không có khuyến mãi";
  },
  transformDateToMinutes(time) {
    return moment(time).hours() * 60 + moment(time).minutes();
  },
  transformTimeToMinutes(time) {
    const hour = parseInt(time?.substring(0, 2), 10);
    const minute = parseInt(time?.substring(3), 10);
    const allMinutes = hour * 60 + minute;
    return allMinutes;
  },
  isWorkingTimeActive(from, to) {
    let fromMinutes = 0;
    let toMinutes = 0;
    let fromDate = from;
    let toDate = to;
    if (from?.length > 5 && to?.length > 5) {
      fromDate = from.substring(16, 21);
      toDate = to.substring(16, 21);
    }
    fromMinutes = Helper.transformTimeToMinutes(fromDate);
    toMinutes = Helper.transformTimeToMinutes(toDate);
    const currentDate = new Date();
    const currentMinutes = Helper.transformDateToMinutes(currentDate);
    if (currentMinutes - fromMinutes >= 0 && toMinutes - currentMinutes >= 0) {
      return true;
    }
    return false;
  },
  // Convert "13:00" to ISO 8601 format (2025-05-17T13:00:00.000Z)
  convertTimeToISO(timeString) {
    // Parse the time string (assuming it's in 24-hour format)
    const currentDate = moment().format("YYYY-MM-DD"); // Get current date (2025-05-17)
    const dateTime = moment(`${currentDate} ${timeString}`, "YYYY-MM-DD HH:mm");

    // Convert to ISO 8601 format
    return dateTime.toISOString();
  },
  // Parse @productId from message text
  // Returns: { hasProductTag, productId, cleanText }
  // Example: "Xem sản phẩm này @12345" -> { hasProductTag: true, productId: "12345", cleanText: "Xem sản phẩm này" }
  parseProductTag(message) {
    if (!message || typeof message !== "string") {
      return { hasProductTag: false, productId: null, cleanText: message || "" };
    }

    // Regex pattern: matches @productId where productId is 1-24 alphanumeric characters
    // Negative lookbehind: @ must NOT be preceded by email-valid chars (excludes emails like user@domain)
    // Negative lookahead: @ must NOT be followed by domain pattern like .com (excludes @domain.com)
    const productTagRegex = /(?<![a-zA-Z0-9._+-])@([a-zA-Z0-9]{1,24})(?!\.[a-zA-Z])/;
    const match = message.match(productTagRegex);

    if (match) {
      const productId = match[1];
      // Remove the @tag from message to get clean text
      const cleanText = message.replace(match[0], "").trim();
      return { hasProductTag: true, productId, cleanText };
    }

    return { hasProductTag: false, productId: null, cleanText: message };
  },

  calculateRemainningPromotionTime(discountTime) {
    if (discountTime && discountTime[DAY_NUMBER]?.time) {
      const workingTimeListInCurrentDay = discountTime[DAY_NUMBER]?.time;
      let promotionTimeResult = "";
      let isPromotionTimeActive = false;
      if (
        !workingTimeListInCurrentDay ||
        workingTimeListInCurrentDay.length === 0
      ) {
        return null;
      }
      for (
        let index = 0;
        index < workingTimeListInCurrentDay?.length;
        index += 1
      ) {
        const fromTime = workingTimeListInCurrentDay?.[index]?.from;
        const toTime = workingTimeListInCurrentDay?.[index]?.to;
        if (Helper.isWorkingTimeActive(fromTime, toTime)) {
          isPromotionTimeActive = true;
          promotionTimeResult = toTime;
          break;
        }
      }

      if (isPromotionTimeActive) {
        const timeISO = Helper.convertTimeToISO(promotionTimeResult);
        return Helper.calculateRemainingTime(new Date(timeISO));
      }
      return null;
    }
    return null;
  },
};

export default Helper;
